// removed by extract-text-webpack-plugin
module.exports = {"attribute":"rZARQ","label":"_2aHOn","value":"_3B04h"};